import axios from 'axios';

export async function forgotPassword(email) {
  if (!email) {
    throw new Error('Email is required.');
  }
  const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/public/password/forgot`, {
    email
  });
  return response.data;
}

export async function validateResetToken(token) {
  if (!token) {
    throw new Error('Token is required.');
  }
  const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}/v1/public/password/validate-token?token=${encodeURIComponent(token)}`
  );
  return response.data;
}

export async function resetPassword(token, password) {
  if (!token || !password) {
    throw new Error('Token and password are required.');
  }
  const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/public/password/reset`, {
    token,
    password
  });
  return response.data;
}
